import { createContext, useContext } from "react";
export type CreationRequest = {
  resource: "contacts" | "companies";
  defaults?: Record<string, unknown>;
};
export const CreationContext = createContext<
  ((request: CreationRequest) => void) | undefined
>(undefined);
export const useCreation = () => useContext(CreationContext);
